import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import { SharedConfigService } from "./shared-config.service";
import { GetShortUrlResult } from "../models/document-scanning.models";

@Injectable({
  providedIn: 'root'
})
export class ShortUrlService {

  constructor(
    private httpClient: HttpClient,
    private configService: SharedConfigService) {
  }

  getShortUrl(longUrl: string): Observable<GetShortUrlResult> {
    return new Observable((observer) => {
      this.configService.getConfig().then((config) => {
        const shortenUrlApi = config.apiUrl + `/short-url/create-short-url`;
        this.httpClient
          .post<GetShortUrlResult>(shortenUrlApi, { LongUrl: longUrl })
          .subscribe(
            (result) => {
              observer.next(result); // Emit the result to the observer
              observer.complete(); // Complete the observer
            },
            (error) => {
              observer.error(error); // Emit the error to the observer
            }
          );
      });
    });
  }
}
